import { render, staticRenderFns } from "./VxFileUpload.vue?vue&type=template&id=0062a678&scoped=true"
import script from "./VxFileUpload.vue?vue&type=script&lang=js"
export * from "./VxFileUpload.vue?vue&type=script&lang=js"
import style0 from "./VxFileUpload.vue?vue&type=style&index=0&id=0062a678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062a678",
  null
  
)

export default component.exports